import { render } from "./SelectedInstitution.vue?vue&type=template&id=e55fb020"
import script from "./SelectedInstitution.vue?vue&type=script&lang=js"
export * from "./SelectedInstitution.vue?vue&type=script&lang=js"

import "./SelectedInstitution.vue?vue&type=style&index=0&id=e55fb020&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__